import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AiSolutionUsageInfo } from '@/app/interfaces/ai-solution-usage';
import { SpanishDatePipe } from '@/app/pipe/date.pipe';
import { AiSolutionUsageService } from '@/app/services/ia-services/ai-solution-usage.service';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { getProjectStateInfo } from '@/app/shared/mappers/project-state.mapper';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-ai-solution-usage-card',
  standalone: true,
  imports: [CommonModule, DesyAngularModule, SpanishDatePipe, ButtonsComponent],
  templateUrl: './ai-solution-usage-card.component.html',
  styleUrl: './ai-solution-usage-card.component.scss',
})
export class AiSolutionUsageCardComponent {
  @Input() id: number | null = null;
  @Input() usageName = '';
  @Input() solutionType = '';
  @Input() requestingPerson = '';
  @Input() creationDate: Date | string | null = null;
  @Input() infoCard: AiSolutionUsageInfo[] = [];
  @Input() expectedUse = '';
  @Input() dataPerRow = 3;
  @Input() showReviewButton = false;

  private _state = '';
  @Input() set state(value: string) {
    this._state = value;
    this.color = getProjectStateInfo(value).className;
  }
  get state(): string {
    return this._state;
  }

  color = '';
  isReviewing = false;

  constructor(
    private aiSolutionUsageService: AiSolutionUsageService,
    private router: Router
  ) {}

  get stateText(): string | null {
    if (this.state.toUpperCase() === 'PENDING') {
      return 'Pendiente de evaluación';
    }

    return this.state ? getProjectStateInfo(this.state).label : null;
  }

  get dataPerRowMdClass(): string {
    const columnClasses: Record<number, string> = {
      1: 'md:grid-cols-1',
      2: 'md:grid-cols-2',
      3: 'md:grid-cols-3',
      4: 'md:grid-cols-4',
      5: 'md:grid-cols-5',
      6: 'md:grid-cols-6',
    };

    return columnClasses[this.dataPerRow] ?? columnClasses[3];
  }

  isListValue(value: string | string[] | null): value is string[] {
    return Array.isArray(value);
  }

  get detailUrl(): string | null {
    return this.id === null ? null : `/catalogo-ia/uso-de-solucion-ia/detalles/${this.id}`;
  }

  async reviewAiSolutionUsage(): Promise<void> {
    if (this.id === null || this.isReviewing) {
      return;
    }

    if (this.state.toUpperCase() === 'EVALUATING') {
      await this.router.navigate(['/catalogo-ia/uso-de-solucion-ia/detalles', this.id]);
      return;
    }

    this.isReviewing = true;

    try {
      await this.aiSolutionUsageService.changeAiSolutionUsageState({
        codigoUsoSolucion: this.id,
        state: 'EVALUATING',
        comentario: '',
      });
      await this.router.navigate(['/catalogo-ia/uso-de-solucion-ia/detalles', this.id]);
    } finally {
      this.isReviewing = false;
    }
  }
}
